var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcona2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_2",
    "data-name": "Livello 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 93.94 93.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: none;\n        stroke: #eb0028;\n        stroke-miterlimit: 10;\n        stroke-width: 3px;\n      }\n\n      .cls-2 {\n        stroke-dasharray: 0 0 9.92 7.93;\n      }\n\n      .cls-3 {\n        fill: #eb0028;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_1-2",
    "data-name": "Livello 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 46.97,
    cy: 46.97,
    r: 45.47
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 47.76,
    cy: 46.97,
    r: 26.28
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 47.76,
    cy: 46.97,
    r: 4.43
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcona2);
export default __webpack_public_path__ + "static/media/Icona_2.524c4637c6493520120e6915ebf4a12c.svg";
export { ForwardRef as ReactComponent };